<template>
  <div class="d-flex justify-center mt-5">
    <v-dialog
      scrollable
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="dialog"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small outlined color="white" v-bind="attrs" v-on="on">
          {{ $translate('TERMSOFUSE') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="justify-space-between">
          <h3>{{ $translate('TERMSOFUSE') }}</h3>
          <v-btn @click="dialog = false" icon>
            <v-icon dark>
              {{ mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div v-html="termsTemplate" class="pt-5"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mdiClose } from '@mdi/js';
import TermsTmeplates from './TermsTemplates.js';
export default {
  data() {
    return {
      dialog: false,
      mdiClose: mdiClose,
    };
  },
  computed: {
    ...mapState(['templateConfig']),
    termsTemplate() {
      //selecting template according to the language of the templateConfig.
      switch (this.templateConfig.language) {
        case 'ar':
          return TermsTmeplates.TermsAr;
        case 'fr':
          return TermsTmeplates.TermsFr;
        default:
          return TermsTmeplates.TermsEn;
      }
    },
  },
};
</script>
